import type { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import TaskDescription from "../../shared/components/TaskDescription";
import t from "../../shared/translations";
import ShowError from "../components/ShowError";
import { graphql } from "../gql";
import LockedModal, { useLockedModal } from "../LockedModal";
import WithTasksSidebar from "../tasksSidebar";

const query = graphql(`
    query AppEventQuery($id: ID!) {
        event(id: $id) {
            id
            icon
            name
            inspiration {
                id
                mediaType
                src
            }
            media {
                id
                mediaType
                src
                name
                logo
            }
            eventStart
            eventEnd
            objectives
            description
            learningPathItem { id }
        }
    }
`);

function Event(): JSX.Element {
    const location = useLocation();
    // Extract id from pathname: /event/123/... -> 123
    const id = location.pathname.split("/")[2];
    const [result] = useQuery({
        query,
        variables: { id },
    });
    const { openLockedModal, ...lockedProps } = useLockedModal();

    let main = <div />;
    if (result.fetching) {
        main = <Loader />;
    } else if (result.error) {
        main = <ShowError />;
    } else if (!result.data.event) {
        main = <Navigate to="/landing" replace={true} />;
    } else {
        const event = result.data.event;
        main = (
            <TaskDescription
                name={event.name}
                objectives={event.objectives}
                inspiration={event.inspiration}
                icon={event.icon}
                miles={null}
                media={event.media}
                eventStart={event.eventStart}
                eventEnd={event.eventEnd}
                taskVariants={[]}
                invert={false}
                description={event.description}
            />
        );
    }
    return (
        <>
            <WithTasksSidebar
                openLockedModal={openLockedModal}
                activeItem={result.data?.event?.learningPathItem?.id}
                mainLabel={t("player.event.tab-event")}
                big={true}
            >
                {main}
            </WithTasksSidebar>
            <LockedModal {...lockedProps} />
        </>
    );
}

export default Event;
